import axios from 'axios';

const createInteraction = (data) => {
  let idata = oa.actions.createInteraction(data).then(
    function(data) {
      return data;
    },
    function() {
      console.log("error");
      return null;
    });
  return idata;
};

const createLeadForInteraction = (data, interactionKey) => {
  let ldata = oa.actions.createLeadForInteraction(data, interactionKey).then(
    function(data) {
      return data;
    },
    function() {
      console.log("error");
      return null;
    });
  return ldata;
};

export default {
  createInteraction,
  createLeadForInteraction,
};
